import React from 'react';
import { FormControl, Select, OutlinedInput, SelectChangeEvent } from '@mui/material';

interface IItem {
  id: string;
  label: string;
}

interface DropdownProps {
  items: IItem[];
  onChangeCallback: (value: string) => void;
  placeholderTitle: string;
  defaultValue?: string;
  classifier?: string;
  disabled?: boolean;
  style?: any;
  cypressId: string;
  size?: 'small' | 'medium';
}

const Dropdown: React.FC<DropdownProps> = ({
  items,
  onChangeCallback,
  disabled,
  defaultValue,
  classifier,
  placeholderTitle,
  style,
  cypressId,
  size = 'medium',
}) => {
  const [value, setValue] = React.useState(() => defaultValue || '');
  React.useEffect(() => {
    defaultValue && setValue(defaultValue);
  }, [defaultValue]);
  return (
    <FormControl variant="outlined" style={style}>
      <Select
        native
        size={size}
        id="training-set-dropdown"
        data-testid="select-dropdown"
        style={{ color: `${value ? '' : '#b3b3b3'}` }}
        disabled={disabled}
        value={value}
        onChange={(e: SelectChangeEvent<string>) => {
          const selectedValue = e.target.value;
          setValue(selectedValue);
          onChangeCallback(selectedValue);
        }}
        input={<OutlinedInput name="item" />}
        data-cy={cypressId}
      >
        <option value="">{placeholderTitle}</option>
        {items.map((t) => (
          <option key={t.id} value={t.id} data-cy={t.label}>
            {classifier === t.id ? `[Classifier] ${t.label}` : t.label}
          </option>
        ))}
      </Select>
    </FormControl>
  );
};

export default Dropdown;
